import browsersNotSupported from '../config/browsers-not-supported';

export default function isBrowserNotSupported(browserName: string) {
  return browsersNotSupported.some((browser) => browser === browserName);
}
